
import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import { Typography } from '@material-ui/core';

import {
  withMeetingContext,
  MeetingContextDeviceControlsProps,
} from 'Scenes/_root/meetingContext';

const getWarningText = (hasAudioDevice, hasVideoDevice) => {
  const warnings = [];
  if (!hasAudioDevice) {
    warnings.push('audio');
  }
  if (!hasVideoDevice) {
    warnings.push('video');
  }
  return warnings.join(' or ');
};

const NoDeviceSetWarnings = ({ deviceControls, registerMeetingCallbacks }) => {
  const [hasAudioDeviceId, setHasAudioDeviceId] = useState(false);
  const [hasVideoDeviceId, setHasVideoDeviceId] = useState(false);
  const checkIfHasAudio = () => {
    const { audioIn } = deviceControls.getSelectedDeviceIds();
    if (audioIn) {
      setHasAudioDeviceId(true);
    } else if (!audioIn) {
      setHasAudioDeviceId(false);
    }
  };
  const checkIfHasVideo = () => {
    const { video } = deviceControls.getSelectedDeviceIds();
    if (video) {
      setHasVideoDeviceId(true);
    } else if (!video) {
      setHasVideoDeviceId(false);
    }
  };

  useEffect(() => {
    checkIfHasAudio();
    checkIfHasVideo();

    return registerMeetingCallbacks('noDeviceSettingsWarnings', {
      onSelectedAudioInDeviceIdUpdated: checkIfHasAudio,
      onSelectedVideoDeviceIdUpdated: checkIfHasVideo,
    });
  }, []);
  return (
    <React.Fragment>
      {
        (!hasAudioDeviceId || !hasVideoDeviceId) && (
          <Typography variant='h6'>
            No {getWarningText(hasAudioDeviceId, hasVideoDeviceId)} settings found
          </Typography>
        )
      }
    </React.Fragment>
  );
};

NoDeviceSetWarnings.propTypes = {
  deviceControls: MeetingContextDeviceControlsProps,
  registerMeetingCallbacks: func.isRequired,
};

export default withMeetingContext([
  'deviceControls',
  'registerMeetingCallbacks',
])(NoDeviceSetWarnings);
